import { requestGet, requestPost, requestPut, requestDelete } from "../config/Api";

// Devuelve solo las definiciones activas (para el picker del usuario)
export const getSourceTypeDefinitions = () =>
  requestGet("/attachment/source-type-definitions");

// Admin: todas (activas e inactivas)
export const getAllSourceTypeDefinitions = () =>
  requestGet("/attachment/source-type-definitions/all");

export const createSourceTypeDefinition = (data) =>
  requestPost("/attachment/source-type-definitions/", data);

export const updateSourceTypeDefinition = (id, data) =>
  requestPut(`/attachment/source-type-definitions/${id}`, data);

export const deleteSourceTypeDefinition = (id) =>
  requestDelete(`/attachment/source-type-definitions/${id}`);
